import { useNavigate } from 'react-router-dom';
import '../styles/Footer.css';
import teczLogo from '../Assets/teczo.png';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="dw-footer">
      <div className="dw-footer__inner">

        <div className="dw-footer__grid">

          {/* Left: Brand + LinkedIn */}
          <div className="dw-footer__brand">
            <div className="dw-footer__logo" onClick={() => navigate('/')}>
              <img src={teczLogo} alt="Teczo" className="dw-footer__logo-img" />
              <span className="dw-footer__logo-divider">|</span>
              <div>
                <div className="dw-footer__logo-name">DigitalWorks</div>
                <div className="dw-footer__logo-sub">Teczo Subsidiary</div>
              </div>
            </div>
            <p className="dw-footer__desc">
              Architecting the operating system for digital industries — bridging
              physical assets with intelligent systems.
            </p>
            <a href="https://www.linkedin.com/company/teczo-sdn-bhd" target="_blank" rel="noreferrer" className="dw-footer__linkedin">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>

          {/* Middle: Contact Us */}
          <div className="dw-footer__contact-block">
            <h3 className="dw-footer__section-title">Contact Us</h3>
            <div className="dw-footer__contact-cols">
              <div className="dw-footer__addresses">
                <div className="dw-footer__address-group">
                  <p className="dw-footer__address-label">Headquarters (Malaysia)</p>
                  <div className="dw-footer__address-text">
                    <p>Suite 12, WORQ Sunway Putra,</p>
                    <p>Level 4-1, Sunway Putra Mall,</p>
                    <p>100, Jalan Putra, Chow Kit,</p>
                    <p>50350 Kuala Lumpur,</p>
                    <p>W.P. Kuala Lumpur, Malaysia</p>
                  </div>
                </div>
                <div className="dw-footer__address-group">
                  <p className="dw-footer__address-label">Regional Office (Australia)</p>
                  <div className="dw-footer__address-text">
                    <p>40/57 Frederick Street,</p>
                    <p>Belmont, 6104,</p>
                    <p>Western Australia, Australia</p>
                  </div>
                </div>
              </div>
              <div className="dw-footer__inquiries">
                <p className="dw-footer__address-label">Inquiries</p>
                <a href="mailto:connect@teczo.co" className="dw-footer__email">connect@teczo.co</a>
                <p className="dw-footer__response-time">Response time: Within 24 hours</p>
              </div>
            </div>
          </div>

          {/* Right: Sitemap */}
          <div className="dw-footer__sitemap">
            <h3 className="dw-footer__section-title">Sitemap</h3>
            <ul className="dw-footer__links">
              <li><span onClick={() => navigate('/')}>Home</span></li>
              <li><span onClick={() => navigate('/about')}>About Us</span></li>
              <li><span onClick={() => navigate('/services')}>Services</span></li>
              <li><span onClick={() => navigate('/contact')}>Contact Us</span></li>
            </ul>
          </div>

        </div>

        <div className="dw-footer__bottom-bar">
          <span>© 2026 Teczo. All Rights Reserved. Powered by VeltrixArcStudio</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
